

import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PersistenceService } from 'angular-persistence';
import { MessageService } from 'primeng/components/common/messageservice';
import { Shipment } from '../../models/shipment.model';
import { ShipmentService, RequestShipmentService, UploadService, UserService, HubService, BoxService, ServiceDVGTService, IncidentsService } from '../../services/index';
import { LadingSchesule, Hub, ListReceiptMoney, Boxes, ServiceDVGT } from '../../models/index';
import { BaseComponent } from '../../shared/components/baseComponent';
import { Constant } from '../../infrastructure/constant';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ListReceiptMoneyService } from '../../services/receiptMoney.service';
import { ShipmentTracking } from '../../models/abstract/shipmentTracking.interface';
import { environment } from '../../../environments/environment';
import { PermissionService } from '../../services/permission.service';
import { Router } from '@angular/router';
import { ChildRequestShipmentTracking } from '../../models/abstract/childRequestShipmentTracking.interface';
import { StringHelper } from '../../infrastructure/string.helper';
import { Accordion, OverlayPanel } from 'primeng/primeng';
import { Incidents } from '../../models/incidents.model';
import { ShipmentFilterViewModel } from '../../models/shipmentFilterViewModel';
import { ShipmentContract } from '../../models/abstract/shipmentContract.interface';
import { DomSanitizer } from '@angular/platform-browser';
import { SearchDate } from '../../infrastructure/searchDate.helper';
import { SelectModel } from '../../models/select.model';
import { Transactionhistory } from '../../models/transactionHistory.model';

@Component({
  selector: 'app-shipment-detail',
  templateUrl: 'shipment-detail.component.html',
  styles: []
})
export class ShipmentDetailComponent extends BaseComponent implements OnInit {
  //#region param basic
  shipmentName: string = "Vận đơn";
  requestShipmentName: string = "Yêu cầu";
  //#endregion
  totalChildShipments: number = 0;
  hubName = environment;
  receiptCODCode: string;
  receiptPriceCode: string;
  priceEmName: any;
  priceHubName: string;
  codEmName: any;
  codHubName: string;
  shipmentNumber: string = '';
  selectedShipmentType: boolean = true;
  shipmentData: ShipmentTracking = new Object() as ShipmentTracking;
  shipmentLadingSchedule: LadingSchesule[] = [];
  modalTitle: string;
  updateImagePath: any;
  headerr: any;
  contentt: any;

  unit = environment.unit;

  listBillChild: Shipment[] = [];
  listChildRequestShipmentAndShipment: ChildRequestShipmentTracking[] = [];

  cloneParrentShipmentNumber: string;
  cloneChildShipmentNumbers: string[] = [];
  cloneShipmentNumber: string;

  isParrentShipment: boolean = false;
  isChildShipment: boolean = false;
  tabIndex: number = 1;
  @ViewChild("accordion") accordion: Accordion

  boxesLS: Shipment[];
  bsModalRefXemKien: BsModalRef;
  bsModalRefPayment: BsModalRef;
  imagesPickup: any[] = [];
  imagesDelivery: any[] = [];
  imagesIncidents: any[] = [];
  dataModalImages: string[] = [];

  dataModal: Incidents;
  shipmentContrat = new ShipmentContract();
  configImageViewer = {
    wheelZoom: true
  }
  checkIsBox = false;
  ladingSchedules: any[];
  list_Package: ShipmentFilterViewModel[];
  packageLadingSchedule: LadingSchesule[] = [];
  columns: any[] = [
    { field: "shipmentNumberS", header: 'MÃ HÀNG' },
    { field: "shipmentNumber", header: 'MÃ KIỆN' },
    { field: "content", header: 'LOẠI HÀNG HÓA' },
    { field: "structure.name", header: 'NHÓM HÀNG HÓA' },
    { field: "defaultPrice", header: 'CƯỚC CHÍNH' },
    { field: "weight", header: 'TL' },
    { field: "calWeight", header: 'TLQĐ' },
    { field: "boxTypeName", header: 'QUY CÁCH HH' },
    { field: "shipmentStatus.name", header: 'TRẠNG THÁI' },
    { field: "currentHub.name", header: 'KHO GIỮ' },
    { field: "realRecipientName", header: 'NGƯỜI KÝ NHẬN' },
    { field: "shipmentNumberW", header: 'MÃ LK' },
    { field: "pickTruck.truckNumber", header: 'BIỂN SỐ XE' },
  ];
  parentNumber = new ShipmentTracking();
  childenNumber = '';
  before_Id = "";
  item: any;
  butn: HTMLElement;
  tab: number = 1;
  hidden: boolean = false;
  //
  shipmentId: number;
  totalRecords: number = 0;
  rowPerPage: number = 100;
  pageNumber: number = 1;

  serviceDVGTCodes: string = "";
  listTransactionHistory: Transactionhistory[] = []
  //
  listShipmentNumberFilter: any[] = [];
  listShipmentNumber: SelectModel[] = [];
  shipmentNumberSelected: string;
  blockSpecial: RegExp = /^[^<>*!@#$%^&*()=+|]+$/
  dataShipment: ShipmentFilterViewModel = new ShipmentFilterViewModel();
  shipmentStatus: SelectModel[] = [
    { label: '--Chọn--', value: null },
    { label: 'Vận đơn mới tạo', value: 107 }
  ]
  shipmentStatusId: number;
  checkSubmit: boolean = false;
  isEnabled: boolean = true;

  //
  timerFilterShipment: any;

  constructor(private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    public bsModalImageRef: BsModalRef,
    private persistenceService: PersistenceService, protected messageService: MessageService,
    private shipmentService: ShipmentService, private requestShipmentService: RequestShipmentService, private userService: UserService, private hubService: HubService,
    private uploadService: UploadService, protected sanitizer: DomSanitizer, private listReceiptMoneyService: ListReceiptMoneyService, private boxService: BoxService, public permissionService: PermissionService,
    public router: Router,
    private serviceDVGTService: ServiceDVGTService,
    private incidentsService: IncidentsService,

  ) {
    super(messageService, permissionService, router);
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    (<any>$(".ui-table-wrapper")).doubleScroll();
  }

  resetData() {
    this.shipmentData = new Object() as ShipmentTracking;
    this.shipmentLadingSchedule = [];
    this.priceEmName = null;
    this.priceHubName = null;
    this.codEmName = null;
    this.codHubName = null;
  }

  async loadData(shipment: ShipmentTracking, selectedShipmentType = true, isHeader = false, isEnabled = true) {
    this.isEnabled = isEnabled;
    if (shipment.typeId == 5) {
      this.tab = 2;
      this.hidden = true;

      let res = await this.shipmentService.getShipmentContractToPrint({ ids: [shipment.id] });

      res.map(x => {
        if (x.id = shipment.id) {

          this.mapDataContract(x.header, x.rules, x);
          document.getElementById("loadHearder").innerHTML = x.header;
        }
      })


    }
    this.listChildRequestShipmentAndShipment = [];
    this.totalChildShipments = 0;
    this.shipmentData = shipment;
    this.checkIsBox = this.shipmentData.isBox;
    if (!this.checkIsBox) {
      this.parentNumber = this.shipmentData;
    } else {
      const res = await this.shipmentService.getAsync(this.shipmentData.shipmentId);
      if (res) {
        this.parentNumber = res;
      }
    }
    if (isHeader) {
      this.cloneParrentShipmentNumber = this.shipmentData.parrentShipmentNumber;
      this.cloneChildShipmentNumbers = this.shipmentData.childShipmentNumbers ? this.shipmentData.childShipmentNumbers.split(",") : [];
      this.cloneShipmentNumber = this.shipmentData.shipmentNumber;

      this.isParrentShipment = false;
      this.isChildShipment = false;



      if (this.shipmentData.childShipmentNumbers)
        this.isChildShipment = true;
      else
        this.isChildShipment = false;

      setTimeout(() => {
        // this.accordion.activeIndex = 1;
      }, 0);
    }
    this.shipmentLadingSchedule = this.shipmentData.ladingSchedules;
    this.selectedShipmentType = selectedShipmentType;
    this.loadListReceiptMoney(this.shipmentData);
    this.loadUsers(this.shipmentData);

    this.imagesPickup = await this.uploadService.getImageByShipmentId(this.shipmentData.id, 1, null, this.shipmentData.shipmentContactId) || [];
    this.imagesDelivery = await this.uploadService.getImageByShipmentId(this.shipmentData.id, 2) || [];

    if (!this.selectedShipmentType) {
      if (this.shipmentData.shipmentStatus) {
        this.shipmentData.shipmentStatusName = this.shipmentData.shipmentStatus.name;
      }
      if (this.shipmentData.shipmentStatus) {
        this.shipmentData.shipmentStatusName = this.shipmentData.shipmentStatus.name;
      }
      if (this.shipmentData.paymentType) {
        this.shipmentData.paymentTypeName = this.shipmentData.paymentType.name;
      }
      if (this.shipmentData.service) {
        this.shipmentData.serviceName = this.shipmentData.service.name;
      }
      // from location
      if (this.shipmentData.fromWard) {
        this.shipmentData.fromWardName = this.shipmentData.fromWard.name;
        if (this.shipmentData.fromWard.district) {
          this.shipmentData.fromDistrictName = this.shipmentData.fromWard.district.name;
        }
        if (this.shipmentData.fromWard.district.province) {
          this.shipmentData.fromProvinceName = this.shipmentData.fromWard.district.province.name;
        }
      }
      if (this.shipmentData.fromHub) {
        this.shipmentData.fromHubName = this.shipmentData.fromHub.name;
      }
      if (this.shipmentData.toWard) {
        this.shipmentData.toWardName = this.shipmentData.toWard ? this.shipmentData.toWard.name : null;
      }
      if (this.shipmentData.toWard) {
        if (this.shipmentData.toWard.district) {
          if (this.shipmentData.toWard.district.province) {
            this.shipmentData.toProvinceName = this.shipmentData.toWard.district.province.name;
          }
        }
      }
      if (this.shipmentData.toHub) {
        this.shipmentData.toHubName = this.shipmentData.toHub ? this.shipmentData.toHub.name : null;
      }
      if (this.shipmentData.toHubRouting) {
        this.shipmentData.toHubRoutingName = this.shipmentData.toHubRouting ? this.shipmentData.toHubRouting.name : null;
      }

      let cols = [
        Constant.classes.includes.shipment.fromHub,
        Constant.classes.includes.shipment.fromHubRouting,
        Constant.classes.includes.shipment.shipmentStatus,
        Constant.classes.includes.shipment.pickUser,
        Constant.classes.includes.shipment.fromDistrict,
        Constant.classes.includes.shipment.fromProvince,
        Constant.classes.includes.shipment.deliverUser,
        Constant.classes.includes.shipment.paymentType,
        Constant.classes.includes.shipment.sender,
        Constant.classes.includes.shipment.structure,
        Constant.classes.includes.shipment.serviceDVGT,
        Constant.classes.includes.shipment.boxes,
        Constant.classes.includes.shipment.toHub,
        Constant.classes.includes.shipment.toHubRouting,
        Constant.classes.includes.shipment.toWard,
        Constant.classes.includes.shipment.toDistrict,
        Constant.classes.includes.shipment.toProvince
      ];
      if (this.checkIsBox) {

        this.childenNumber = this.shipmentData.shipmentNumber;
        this.isParrentShipment = true;
      }
      else {
        this.isParrentShipment = false;
      }
    }

    this.list_Package = [];
    this.shipmentId = this.parentNumber.id;
    await this.getShipmentBoxByShipment();
    const res = await this.shipmentService.getListTransactionHistoryByShipmentId(shipment.id);
    if (res) {
      this.listTransactionHistory = res;
    }
  }

  async getShipmentBoxByShipment() {
    let res = await this.shipmentService.getShipmentBoxByShipmentIdNew(this.shipmentId, this.isEnabled, this.rowPerPage, this.pageNumber);
    this.totalRecords = res.length > 0 ? res[0].totalCount : 0;
    this.list_Package = [];
    let modal2 = res as ShipmentFilterViewModel[];
    this.list_Package = modal2;
    // for (let i = 0; i < modal2.length; i++) {
    //   modal2[i].isExpan = false;
    //   this.list_Package.push(modal2[i]);
    //   if (i == 0) {
    //     setTimeout(() => {
    //       modal2[i].isExpan = true;
    //       this.load_package(modal2[i], modal2[i].isExpan);
    //       document.getElementById(modal2[i].id).click(); // click vị trí đầu tiên của bảng
    //     }, 100);
    //   }
    // }
  }
  async load_package(modal: ShipmentFilterViewModel, isEx: boolean) {
    this.out_Click();
    this.dataShipment = modal;
    if (isEx) {
      modal.isExpan = false;
    } else {
      modal.isExpan = true;
    }

    let res = await this.shipmentService.getGetLadingScheduleAsync(modal.id);
    this.packageLadingSchedule = res;
    let dataincident = await this.incidentsService.getIncidentImageByShipment(modal.id) || [];
    this.imagesIncidents = [];
    dataincident.map(map => {
      this.imagesIncidents.push(environment.apiPostImage + map.imagePath);
    })
  }

  out_Click() {
    if (this.dataShipment) {
      this.dataShipment.isExpan = false;
    }
  }
  mapDataContract(header, content, shipmentContract) {
    this.item = shipmentContract;
    let templateHeader = header.replace(/{{([^}}]+)?}}/g, ($1, $2) =>
      $2.split('.').reduce((p, c) =>
        p ? ((p[c] || p[c] == 0) ? p[c] : '') : '',
        this));
    // let templateContent = content.replace(/{{([^}}]+)?}}/g, ($1, $2) =>
    //   $2.split('.').reduce((p, c) =>
    //     p ? ((p[c] || p[c] == 0) ? p[c] : '') : '',
    //     this));
    this.headerr = this.sanitizer.bypassSecurityTrustHtml(templateHeader);
    // this.contentt = this.sanitizer.bypassSecurityTrustHtml(templateContent);
  }
  click_package() {
    if (this.checkIsBox) {
      this.butn = document.getElementById(this.shipmentData.id + "");
      this.butn.click();
    }
  }
  loadListReceiptMoney(shipmentData: Shipment) {
    this.listReceiptMoneyService.getListByShipmentId(shipmentData.id).subscribe(x => {
      if (x) {
        const data = x.data as ListReceiptMoney[];
        if (data) {
          if (data.length > 0) {
            if (data[0].totalPrice) {
              this.receiptPriceCode = data[0].code;
            } else {
              this.receiptPriceCode = null;
            }
            if (data[0].totalCOD) {
              this.receiptCODCode = data[0].code;
            } else {
              this.receiptCODCode = null;
            }
          }
        }
      }
    });
  }

  loadUsers(shipmentData: Shipment) {
    const keepingTotalPriceEmpId = shipmentData.keepingTotalPriceEmpId;
    const keepingTotalPriceHubId = shipmentData.keepingTotalPriceHubId;
    const keepingCODEmpId = shipmentData.keepingCODEmpId;
    const keepingCODHubId = shipmentData.keepingCODHubId;

    this.loadPriceEm(keepingTotalPriceEmpId);
    this.loadPriceHub(keepingTotalPriceHubId);
    this.loadCodEm(keepingCODEmpId);
    this.loadCodHub(keepingCODHubId);
  }

  loadPriceEm(id: number) {
    this.userService.get(id).subscribe(x => {
      if (x) {
        const priceEm = x.data as any;
        if (priceEm) {
          this.priceEmName = priceEm.code + " - " + priceEm.fullName;
        }
      }
    });
  }

  loadPriceHub(id: number) {
    this.hubService.get(id).subscribe(x => {
      if (x) {
        const res = x.data as Hub;
        if (res) {
          this.priceHubName = res.name;
        }
      }
    });
  }

  loadCodEm(id: number) {
    this.userService.get(id).subscribe(x => {
      if (x) {
        const codEm = x.data as any;
        if (codEm) {
          this.codEmName = codEm.code + " - " + codEm.fullName;
        }
      }
    });
  }

  loadCodHub(id: number) {
    this.hubService.get(id).subscribe(x => {
      if (x) {
        const res = x.data as Hub;
        if (res) {
          this.codHubName = res.name;
        }
      }
    });
  }

  changeInputSwitch() {
    this.resetData();
  }

  async openModalIncident(template: TemplateRef<any>, rowData: any) {
    this.modalTitle = "Hình ảnh sự cố"
    this.dataModalImages = rowData;
    this.bsModalImageRef = this.modalService.show(template, { class: 'inmodal bounceInRight modal-1000', backdrop: 'static', keyboard: true });

    // this.resetModal();
    // this.dataModal = await this.shipmentService.getIncidentsById(rowData.incidentsId, "HandleByEmp,IncidentsByHub,IncidentsReason,IncidentsByEmp");

    // setTimeout(() => {
    //   this.bsModalRef = this.modalService.show(template, { class: 'inmodal bounceInRight modal-s', backdrop: 'static', keyboard: true });
    // }, 0);

    // this.imagesIncidents = await this.uploadService.getImageByShipmentId(rowData.shipmentId, 3, rowData.incidentsId) || [];

  }

  openModel(template: TemplateRef<any>, path: string) {
    this.modalTitle = "Hình ảnh";
    this.uploadService.getImageByPath(path).subscribe(x => {
      if (!super.isValidResponse(x)) return;

      if (x.data["fileBase64String"]) {
        this.updateImagePath = x;
        this.bsModalImageRef = this.modalService.show(template, { class: 'inmodal bounceInRight modal-s', backdrop: 'static', keyboard: true });
      }
    });
  }

  openModelImages(template: TemplateRef<any>, data: any[]) {
    this.modalTitle = "Hình ảnh giao hàng"
    this.dataModalImages = [];
    data.map(x => {
      this.dataModalImages.push('data:image/jpeg;base64,' + x.fileBase64String);
    })
    this.bsModalImageRef = this.modalService.show(template, { class: 'inmodal bounceInRight modal-1000', backdrop: 'static', keyboard: true });
  }

  async openModelXemKien(template: TemplateRef<any>, id) {
    this.boxesLS = await this.boxService.getByShipmentIdAsync(id);

    this.bsModalRefXemKien = this.modalService.show(template, { class: 'inmodal bounceInRight modal-lg modalXemKien', backdrop: 'static', keyboard: true });
  }

  async onEnterSearchGBDetail(reset = false) {
    if (reset) {
      this.isParrentShipment = false;
      this.isChildShipment = false;
      // this.accordion.activeIndex = 1;
    }

    if (this.shipmentNumber) {
      this.resetData();
      let includes = [
        Constant.classes.includes.shipment.sender,
        Constant.classes.includes.shipment.fromHub,
        Constant.classes.includes.shipment.toHub,
        Constant.classes.includes.shipment.fromWard,
        Constant.classes.includes.shipment.fromDistrict,
        Constant.classes.includes.shipment.fromProvince,
        Constant.classes.includes.shipment.fromHub,
        Constant.classes.includes.shipment.toWard,
        Constant.classes.includes.shipment.toDistrict,
        Constant.classes.includes.shipment.toProvince,
        Constant.classes.includes.shipment.shipmentStatus,
        Constant.classes.includes.shipment.paymentType,
        Constant.classes.includes.shipment.service,
        Constant.classes.includes.shipment.serviceDVGT,
        Constant.classes.includes.shipment.listGoods,
      ];

      let data = null;
      if (this.selectedShipmentType) {
        data = await this.shipmentService.getByShipmentNumberNewAsync(this.shipmentNumber.trim());
      }
      else {
        data = await this.shipmentService.getByShipmentNumberS(this.shipmentNumber.trim(), true, true);
      }
      if (data) {
        if (data.typeId == 5) {
          this.tab = 2;
          this.hidden = true;
          let res = await this.shipmentService.getShipmentContractToPrint({ ids: [data.id] });
          res.map(x => {
            if (x.id = data.id) {
              this.mapDataContract(x.header, x.rules, x);
              document.getElementById("loadHearder").innerHTML = x.header;
              // document.getElementById("loadRules").innerHTML = x.rules;
            }
          })
          this.shipmentData.shipmentTypeName = data.shipmentTypeName;
        }
        else {
          const ladingSchedule = await this.shipmentService.getGetLadingScheduleAsync(data.id);
          if (ladingSchedule) {
            data.ladingSchedules = ladingSchedule;
          }
        }
        if (reset) {
          this.cloneParrentShipmentNumber = data.parrentShipmentNumber;
          this.cloneChildShipmentNumbers = this.shipmentData.childShipmentNumbers ? data.childShipmentNumbers.split(",") : [];
          this.cloneShipmentNumber = data.shipmentNumber;
        }
        if (!this.isParrentShipment) {
          if (data.parrentShipmentNumber)
            this.isParrentShipment = true;
          else
            this.isParrentShipment = false;
        }

        if (!this.isChildShipment) {
          if (data.childShipmentNumbers)
            this.isChildShipment = true;
          else
            this.isChildShipment = false;
        }
        if (data.typeId != 5) {
          this.loadData(data, this.selectedShipmentType);
        }

      }
      else if (!this.selectedShipmentType) {
        this.requestShipmentService.trackingShort(this.shipmentNumber.trim(), includes).subscribe(
          x => {
            if (!super.isValidResponse(x)) return;
            this.loadData(x.data as ShipmentTracking, this.selectedShipmentType);
          }
        );
      }
      const res = await this.shipmentService.getListTransactionHistoryByShipmentId(data.id);
      if (res) {
        this.listTransactionHistory = res;
      }
    }
    // this.shipmentNumber = null;
  }
  clone(model: Shipment): Shipment {
    let data = new Shipment();
    for (let prop in model) {
      data[prop] = model[prop];
    }
    return data;
  }

  onTabOpen(event) {
    this.tabIndex = event.index;
    if (event.index == 0) {
      this.shipmentNumber = this.cloneParrentShipmentNumber;
      this.onEnterSearchGBDetail(false);
    }
    else if (event.index == 1) {
      this.shipmentNumber = this.cloneShipmentNumber;
      this.onEnterSearchGBDetail(false);
    }
    else if (event.index > 1) {
      this.shipmentNumber = this.cloneChildShipmentNumbers[event.index - 2];
      this.onEnterSearchGBDetail(false);
    }
  }

  async loadParrent(data) {
    const res = await this.shipmentService.getByShipmentNumberAsync(data.trim());
    this.checkIsBox = false;
    return this.loadData(res);
  }

  async onPageChange(event: any) {
    this.pageNumber = event.first / event.rows + 1;
    this.rowPerPage = event.rows;
    await this.getShipmentBoxByShipment();
  }

  keyUpEnter() {
    this.onEnterSearchGBDetail(true);
  }

  async filterShipmentNumber(event: any) {
    let value = event.query;
    value = value ? value : null;
    this.shipmentNumber = value;
    clearTimeout(this.timerFilterShipment)
    this.timerFilterShipment = setTimeout(async () => {
      const res = await this.shipmentService.getlistShipmentNumberFilter(value, this.selectedShipmentType);
      if (res) {
        this.listShipmentNumber = [];
        this.listShipmentNumberFilter = [];
        if (this.selectedShipmentType) {
          res.map(x => {
            let createdDate = SearchDate.formatGetDateNoTime(x.createdWhen);
            this.listShipmentNumber.push({ label: `${x.shipmentNumber} - ${createdDate}`, value: x.shipmentNumber });
            this.listShipmentNumberFilter.push(`${x.shipmentNumber} - ${createdDate}`)
          });
        }
        else {
          res.map(x => {
            let createdDate = SearchDate.formatGetDateNoTime(x.createdWhen);
            this.listShipmentNumber.push({ label: `${x.shipmentNumberS} - ${createdDate}`, value: x.shipmentNumberS })
            this.listShipmentNumberFilter.push(`${x.shipmentNumberS} - ${createdDate}`)
          });
        }
      }
    }, 1000)


  }

  onSelectedShipmentNumber() {
    let findS = this.listShipmentNumber.find(x => x.label == this.shipmentNumberSelected);
    if (findS) {
      this.shipmentNumber = findS.value;
      this.shipmentNumberSelected = findS.value;
    }
    else {
      this.shipmentNumber = null;
    }
  }

  openModelReceiptMoney(template: TemplateRef<any>) {
    this.bsModalRefPayment = this.modalService.show(template, { class: 'inmodal bounceInRight modal-lg', backdrop: 'static', keyboard: true });
  }

  UpdateShipmentStatus(template: TemplateRef<any>) {
    this.bsModalRefPayment = this.modalService.show(template, { class: 'inmodal bounceInRight modal-s', backdrop: 'static', keyboard: true });
  }

  async confirmUpdateShipmentStatus() {
    if (this.shipmentStatusId) {
      let model = new ShipmentFilterViewModel();
      model.shipmentStatusId = this.shipmentStatusId;
      model.ShipmentNumber = this.cloneShipmentNumber;
      this.checkSubmit = true;
      const res = await this.shipmentService.updateStatusShipment(model);
      if (res) {
        this.messageService.add({
          severity: Constant.messageStatus.success,
          detail: "Cập nhật trạng thái thành công",
        })
      }
      this.checkSubmit = false;
      this.bsModalRefPayment.hide();
    }
    else {
      this.messageService.add({
        severity: Constant.messageStatus.warn,
        detail: "Vui lòng chọn trạng thái",
      })
    }
  }
  viewIncident() {

  }
}

